import timeOfDay from '@/filters/time-of-day';



function parseOrderItem(item) {
  const computed = {};

  if (item.schedule && item.schedule.length > 0) {
    computed.schedulesPerDay = {
      Sunday: [],
      Monday: [],
      Tuesday: [],
      Wednesday: [],
      Thursday: [],
      Friday: [],
      Saturday: []
    };

    /*
      NOTE:
      If both startTime and endTime are 00:00:00, that means the whole day is NOT valid.
      If startTime is 00:00:00 and endTime is 23:59:59, that means the whole day is valid.
    */

    item.schedule.forEach((schedule) => {
      if (schedule.startTime === '00:00:00' && schedule.endTime === '00:00:00') {
        computed.schedulesPerDay[schedule.day].push({
          ...schedule,
          display: 'Not Available'
        });
      }

      else if (schedule.startTime === '00:00:00' && schedule.endTime === '23:59:59') {
        computed.schedulesPerDay[schedule.day].push({
          ...schedule,
          display: 'All Day'
        });
      }

      else {
        const startTimeDisplay = timeOfDay(schedule.startTime, true);
        const endTimeDisplay = timeOfDay(schedule.endTime, true);

        computed.schedulesPerDay[schedule.day].push({
          ...schedule,
          display: `${startTimeDisplay}–${endTimeDisplay}`
        });
      }
    });

    Object.keys(computed.schedulesPerDay).forEach((day) => {
      if (computed.schedulesPerDay[day].length === 0) {
        delete computed.schedulesPerDay[day];
      }
    });
  }

  return {
    ...item,
    ...computed
  };
}



export default parseOrderItem;
